import React, { Component } from 'react';
import '../../../../../styles/components/app-download-section.scss';
import { Bell, Globe, Layers, ShieldCheck } from 'lucide-react';
import i18n from '../../../../../i18n';

class AppDownloadSection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <section className="app-download-section">
        <div className="app-download-container">
          {/* Left Content */}
          <div className="app-content">
            {/* Badge */}
            {/* <div className="available-badge">
              <span className="badge-dot"></span>
              {i18n.t('c_available_now')}
            </div> */}

            {/* Main Heading */}
            <h1 className="app-heading">
              {i18n.t('bid_smarter')}
              <br />
              {i18n.t('win_faster')}
              <br />
              <span className="app-heading-accent">{i18n.t('anywhere')}</span>
            </h1>

            {/* Description */}
            <p className="app-description">{i18n.t('available_now_description')}</p>

            {/* Features Grid */}
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon feature-icon-bidding">
                  <Layers />
                </div>
                <div className="feature-text">
                  <h3 className="feature-title"> {i18n.t('live_bidding')}</h3>
                  <p className="feature-desc">{i18n.t('real_time_auctions')}</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon feature-icon-alerts">
                  <Bell />
                </div>
                <div className="feature-text">
                  <h3 className="feature-title">{i18n.t('instant_alerts')}</h3>
                  <p className="feature-desc">{i18n.t('never_miss_a_bid')}</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon feature-icon-payments">
                  <ShieldCheck />
                </div>
                <div className="feature-text">
                  <h3 className="feature-title">{i18n.t('secure_payments')}</h3>
                  <p className="feature-desc">{i18n.t('trusted_gateways')}</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon feature-icon-language">
                  <Globe />
                </div>
                <div className="feature-text">
                  <h3 className="feature-title">{i18n.t('dual_language')}</h3>
                  <p className="feature-desc">{i18n.t('arabic_english')}</p>
                </div>
              </div>
            </div>

            {/* Download Buttons */}
            <div className="download-buttons">
              <a
                href={'https://apps.apple.com/qa/app/mzadcom/id6754008508'}
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn-link"
              >
                <img
                  src="assets/images/app/appStoreBadge.svg"
                  alt="Download on the App Store"
                  className="download-badge-img"
                />
              </a>

              <a
                href={'https://play.google.com/store/apps/details?id=com.mzadcom.mzadcom'}
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn-link"
              >
                <img
                  src="assets/images/app/googlePlayBadge.svg"
                  alt="Get it on Google Play"
                  className="download-badge-img"
                />
              </a>
            </div>

            {/* QR Code Section */}
            {/* <div className="qr-section">
              <div className="qr-code">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0" y="0" width="100" height="100" fill="white" />
                  <rect x="5" y="5" width="35" height="35" fill="black" />
                  <rect x="10" y="10" width="25" height="25" fill="white" />
                  <rect x="15" y="15" width="15" height="15" fill="black" />
                  <rect x="60" y="5" width="35" height="35" fill="black" />
                  <rect x="65" y="10" width="25" height="25" fill="white" />
                  <rect x="70" y="15" width="15" height="15" fill="black" />
                  <rect x="5" y="60" width="35" height="35" fill="black" />
                  <rect x="10" y="65" width="25" height="25" fill="white" />
                  <rect x="15" y="70" width="15" height="15" fill="black" />
                  <rect x="45" y="45" width="10" height="10" fill="black" />
                  <rect x="60" y="60" width="10" height="10" fill="black" />
                  <rect x="50" y="70" width="10" height="10" fill="black" />
                  <rect x="70" y="50" width="10" height="10" fill="black" />
                </svg>
              </div>
              <div className="qr-text">
                <h4 className="qr-title">Scan to Download</h4>
                <p className="qr-desc">
                  iOS & Android <MoveRight />
                </p>
              </div>
            </div> */}
          </div>

          {/* Right Content - Phone Mockup */}
          <div className="phone-mockup-container">
            {/* Phone Frame */}
            <div className="phone-frame">
              <img
                src="assets/images/app/app-preview-shadow.png"
                alt="phone-preview"
                className="phone-frame-img"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AppDownloadSection;
